export default "__VITE_ASSET__CCCatSPS__"